import { NodeIdPlugin, createNodeIdPlugin } from "@udecode/plate"

import { MyEditor, MyValue } from "../types"

export const nodeIdPlugin = createNodeIdPlugin<
  NodeIdPlugin,
  MyValue,
  MyEditor
>()
